export default __webpack_public_path__ + "static/media/DF_Characters_Suchaow1.7d4fb882.png";